type UTMParams = Record<string, any>

const TRUE_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_adgroup',
  'utm_network',
  'utm_placement',
  'gclid',
  'fbclid',
]

function pickTruthy(obj: UTMParams) {
  return Object.entries(obj || {}).reduce((acc, [previous, current]) => {
    if (current !== undefined && current !== null && `${current}`.trim() !== '')
      acc[previous] = current
    return acc
  }, {} as UTMParams)
}

export function getAttributionFields(storeUtmParams: UTMParams = {}) {
  const base = { ...storeUtmParams }

  try {
    const ss = sessionStorage || undefined
    if (ss) {
      const g = ss.getItem('gclid') || ss.getItem('gcl_id')
      const f = ss.getItem('fbclid')
      if (g && !base.gclid) base.gclid = g
      if (f && !base.fbclid) base.fbclid = f
    }
  } catch {
    // Intentionally ignoring sessionStorage errors
  }

  const filtered = pickTruthy(
    Object.fromEntries(Object.entries(base).filter(([k]) => TRUE_KEYS.includes(k)))
  )

  return filtered
}
